export const NOTIFICATION_TYPES = {
  NEW_CHAT_MESSAGE: 'new_chat_message',
}
